<template>
  <div class="index">
    <div class="itemBox">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="item + index"
        @click="toGy(item)"
      >
        <div class="num">
          <span class="numfont" style="font-size: 30px">{{ item.num }}</span
          >个
        </div>
        <div class="content">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [
          {
            name: "社会组织",
            num: "751",
          },
          {
            name: "社会组织党组织",
            num: "350",
          },
          {
            name: "公益党建联盟",
            num: "1158",
          },
        ];
      },
    },
  },
  methods: {
    toGy(item) {
      // console.log(item);
      console.log("点击");
      if (item.name == "公益党建联盟") {
        console.log(item.name)
        // 页面跳转
        this.$router.push({
          path: "/league",
        });
      } else if (item.name == "社会组织") {
        this.$router.push({
          path: "/orgTeam",
        });
      } else if(item.name == "社会组织党组织"){
        this.$router.push({
          path: "/orgTeam",
          query: {
            isParties: 1,
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  cursor: pointer;
  width: 90%;
  height: 90px;
  .itemBox {
    width: 100%;
    display: flex;
    color: #fff;
    justify-content: space-between;
    .item {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 29%;
      height: 70px;
      background: url("../../../assets/images/pageHome/msgItem.png") no-repeat
        center/100% 100%;
      .num {
        font-weight: bold;
        transform: translateY(-20px);
        .numfont {
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #fff;
        }
      }
      .content {
        transform: translateY(-22px);
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
